module.exports = __webpack_public_path__ + "img/data.da035950.png";